export default __webpack_public_path__ + "static/media/hero-d.a26197e9.png";